/** India country calling code used as a fixed UI prefix. */
export const INDIA_COUNTRY_CODE = '+91';

const TEN_DIGIT = /^\d{10}$/;

/** Keep only digits and cap at 10 (national number). */
export function digitsOnlyNational(value: string): string {
  return value.replace(/\D/g, '').slice(0, 10);
}

/** Convert 10 national digits to E.164 (`+91XXXXXXXXXX`). */
export function toE164India(digits: string): string {
  const national = digitsOnlyNational(digits);
  return `${INDIA_COUNTRY_CODE}${national}`;
}

/**
 * Extract 10 national digits from a stored E.164 / local value.
 * Prefer stripping a leading +91 / 91 when present.
 */
export function fromE164India(value: string | null | undefined): string {
  if (!value) return '';
  const trimmed = value.trim();
  if (!trimmed) return '';

  const withoutPlus = trimmed.startsWith('+') ? trimmed.slice(1) : trimmed;
  const digits = withoutPlus.replace(/\D/g, '');

  if (digits.startsWith('91') && digits.length >= 12) {
    return digits.slice(-10);
  }
  return digits.slice(-10);
}

export function isValidIndianMobile(digits: string): boolean {
  return TEN_DIGIT.test(digitsOnlyNational(digits));
}

export const indianMobileSchemaMessage = 'Enter a valid 10-digit mobile number';
